import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { ClipboardCheck, Zap } from 'lucide-react';
import { t } from '@lingui/core/macro';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { useCheckPermission } from '../hooks/useCheckPermission';

export function SupportTasksLayout() {
  const canViewTasks = useCheckPermission('canViewSupportTasks');
  const canManageRules = useCheckPermission('canManageAutomationRules');

  const items = useMemo<MenuItemsType[]>(() => {
    const menu: MenuItemsType[] = [];
    if (canViewTasks) {
      menu.push({
        id: 'tasks',
        label: t`Tasks`,
        link: '/tasks',
        icon: ClipboardCheck,
      });
    }
    if (canManageRules) {
      menu.push({
        id: 'automation-rules',
        label: t`Automation Rules`,
        link: '/tasks/automation-rules',
        icon: Zap,
      });
    }
    return menu;
  }, [canViewTasks, canManageRules]);

  return (
    <SidebarLayout items={items} label={t`Support Tasks`}>
      <Outlet />
    </SidebarLayout>
  );
}
